import {
  Component,
  Input,
  OnInit,
  OnChanges,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
  forwardRef,
} from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";

/**
 * Input component used to type dimension values in inches, cm or mm.
 */
@Component({
  selector: "n-input-dimension",
  templateUrl: "./input-dimension.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDimensionComponent),
      multi: true,
    },
  ],
})
export class InputDimensionComponent implements ControlValueAccessor {
  @ViewChild("container", { read: ElementRef }) container: ElementRef;
  _valueInInch: number;
  _valueInMM: number;
  _valueInCM: number;
  _valueInPercentage: number;
  @Input() parentSize: number = 0;
  @Input() readonly: boolean;
  disabled: boolean;
  @Output() changed: EventEmitter<any> = new EventEmitter();

  @Output() blurChanged: EventEmitter<any> = new EventEmitter();

  @Input()
  unit: string = "in";

  constructor(public elementRef: ElementRef) {}

  get valueInInch(): number {
    return this._valueInInch;
  }

  get valueInMM(): number {
    return this._valueInMM;
  }

  get valueInCM(): number {
    return this._valueInCM;
  }

  get valueInPercentage(): number {
    return this._valueInPercentage;
  }

  @Input()
  set valueInInch(value: number) {
    this._valueInInch = value;
    this._valueInMM = Math.round(this._valueInInch * 25.4);
    this._valueInCM = this.valueInMM / 10;
    this._valueInPercentage = +(this._valueInInch / this.parentSize).toFixed(2);
    this.onChange(this._valueInPercentage);
  }

  set valueInMM(value: number) {
    this._valueInMM = value;
    this._valueInCM = value / 10;
    this._valueInInch = +(this._valueInMM / 25.4).toFixed(2);
    this._valueInPercentage = +(this._valueInInch / this.parentSize).toFixed(2);
    this.onChange(this._valueInPercentage);
  }

  set valueInCM(value: number) {
    this._valueInCM = value;
    this._valueInMM = value * 10;
    this._valueInInch = +(this._valueInMM / 25.4).toFixed(2);
    this._valueInPercentage = +(this._valueInInch / this.parentSize).toFixed(2);
    this.onChange(this._valueInPercentage);
  }
  set valueInPercentage(value: number) {
    this._valueInPercentage = value;
    this._valueInInch = +(this.parentSize * this._valueInPercentage).toFixed(2);
    this._valueInMM = Math.round(this._valueInInch * 25.4);
    this._valueInCM = this.valueInMM / 10;
    this.onChange(this._valueInPercentage);
  }

  onChange = (delta: any) => {};
  onTouched = () => {};
  onBlurMethod() {
    this.onTouched();
    this.blurChanged.emit();
  }

  writeValue(value: any): void {
    console.log("write value", value);
    this.valueInPercentage = value as number;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
